import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "display-flex align-items-center justify-content-space-between position-relative configure-email-header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "configure-email-heading" }
const _hoisted_5 = {
  key: 1,
  class: "configure-email-content"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "display-flex width100"
}
const _hoisted_8 = {
  key: 2,
  class: "display-flex width100"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 0,
  class: "tab-pane tab-flex-container"
}
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toaster = _resolveComponent("Toaster")!
  const _component_loading = _resolveComponent("loading")!
  const _component_EmailTemplates = _resolveComponent("EmailTemplates")!
  const _component_SideBarPane = _resolveComponent("SideBarPane")!
  const _component_EmailPreviewPane = _resolveComponent("EmailPreviewPane")!
  const _component_ConfigureEmailEditPane = _resolveComponent("ConfigureEmailEditPane")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["configure-email-container", {'mobile-container' : _ctx.isMobile}])
  }, [
    (_ctx.showToaster)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Toaster, {
            message: _ctx.toasterMessage,
            type: _ctx.toasterType,
            "default-timeout": _ctx.toasterDefaultTimeout
          }, null, 8, ["message", "type", "default-timeout"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      "show-loading": _ctx.showLoading,
      "border-color": _ctx.loaderBorderColor
    }, null, 8, ["show-loading", "border-color"]),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.isBackButtonVisible)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: "javascript:void(0)",
            class: "back-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMobile ? _ctx.HandleMobileBackNavigation() : _ctx.HandleBackNavigation()))
          }, [
            _createElementVNode("img", {
              src: _ctx.backIcon,
              class: "back-icon"
            }, null, 8, _hoisted_3),
            _createElementVNode("span", null, _toDisplayString(_ctx.backButtonLabel), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.pageHeader), 1)
    ]),
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.showChangeTemplateScreen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_EmailTemplates, {
                  "all-email-templates": _ctx.templatesCatalogueGallery,
                  onRemoveTemplate: _ctx.RemoveTemplate,
                  onRenameTemplate: _ctx.RenameTemplate,
                  onRedirectToEditPane: _ctx.SetEmailConfigurationEditPaneData
                }, null, 8, ["all-email-templates", "onRemoveTemplate", "onRenameTemplate", "onRedirectToEditPane"])
              ]))
            : (!_ctx.isEditModeOn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_SideBarPane, {
                    "email-categories": _ctx.emailCategories,
                    "current-selected-tab": _ctx.selectedEmailTab
                  }, null, 8, ["email-categories", "current-selected-tab"]),
                  _createVNode(_component_EmailPreviewPane, {
                    "show-preview": _ctx.showPreview,
                    "send-grid-template": _ctx.emailTemplate,
                    onChangePageHeader: _ctx.ChangePageTitle
                  }, null, 8, ["show-preview", "send-grid-template", "onChangePageHeader"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_ConfigureEmailEditPane, {
                    ref: "emailEditPane",
                    "template-preview-data": _ctx.emailTemplate,
                    "corporate-fonts": _ctx.corporateFonts,
                    onHideBackNavigationButton: _ctx.BackButtonHandler,
                    onChangeTemplateScreen: _ctx.NavigateToChangeTemplateScreen,
                    onReloadTemplateData: _ctx.GetListOfTemplates,
                    onDiscardTemplate: _ctx.GetSelectedTemplate,
                    onPageIsDirty: _ctx.DirtyCheckInEditPage,
                    onSaveEmailConfigurations: _ctx.SaveEmailConfigurations
                  }, null, 8, ["template-preview-data", "corporate-fonts", "onHideBackNavigationButton", "onChangeTemplateScreen", "onReloadTemplateData", "onDiscardTemplate", "onPageIsDirty", "onSaveEmailConfigurations"])
                ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.showEmailListingInMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_SideBarPane, {
                  "email-categories": _ctx.emailCategories,
                  "current-selected-tab": _ctx.selectedEmailTab
                }, null, 8, ["email-categories", "current-selected-tab"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_EmailPreviewPane, {
                  "show-preview": _ctx.showPreview,
                  "send-grid-template": _ctx.emailTemplate,
                  onChangePageHeader: _ctx.ChangePageTitle
                }, null, 8, ["show-preview", "send-grid-template", "onChangePageHeader"])
              ]))
        ]))
  ], 2))
}